// 后台配置信息
export const BASE_CONFIG = 'BASE_CONFIG' // 添加用户信息

export const CHECK_MOBILE = 'CHECK_MOBILE'

export const FIXNAV_DH = 'FIXNAV_DH'

export const USER_INFO = 'USER_INFO'

export const SETLOGINUSER = 'SETLOGINUSER' // 修改用户单个信息

export const LOGOUT = 'LOGOUT' // 登出
